module.exports = __webpack_public_path__ + "static/media/error.34767408.svg";